import React, { useContext } from "react";
import { Link } from "react-router-dom";
import EmpresaContext from "../../context";

interface Ipage_header_props {
  headertitle: string;
  subheader?: string | null;
  backgroundImage?: string;
}
const Page_header = (props: Ipage_header_props) => {
  const empresa = useContext(EmpresaContext);
  let HeaderTitle = props.headertitle;
  let Subheader = props.subheader || HeaderTitle;
  const inlineStyle = {
    backgroundImage: `url("${props.backgroundImage || "/assets/img/bg/4.png"}")`
  };
  return (
    <div className="breadcrumb-area jarallax" style={inlineStyle}>
      <style>
        {`
          .breadcrumb-area {
            background-image: ${inlineStyle.backgroundImage};
            ${empresa.info_gen &&
              empresa.info_gen["header-position"] &&
              `background-position: ${empresa.info_gen["header-position"]}`}
          }
          ${empresa.info_gen &&
            empresa.info_gen["page-header-overlay"] &&
            `
            .breadcrumb-area:before {
              background: transparent;
            }
            .breadcrumb-area:after {
              background: none;
            }
            .breadcrumb-area .page-title {
              ${empresa.palleta.cor_texto_navbar_1 &&
                `
              color: ${empresa.palleta.cor_texto_navbar_1};
              `}
            }
            .breadcrumb-area .page-list {
              ${empresa.palleta.cor_texto_navbar_1 &&
                `
              color: ${empresa.palleta.cor_texto_navbar_1};
              `}
            }
          `}
        `}
      </style>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb-inner">
              <h1
                className="page-title"
                style={
                  empresa.frase_topo && {
                    fontSize:
                      "" +
                      (empresa.frase_topo.size
                        ? `${empresa.frase_topo.size}px`
                        : "")
                  }
                }
              >
                {HeaderTitle}
              </h1>
              <ul className="page-list">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>{Subheader}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Page_header.contextType = EmpresaContext;
export default Page_header;
